import { ContentWrapper, Statistic } from '@/components/_common';
import { Tooltip } from 'antd';
import { hasPermissions } from '@/utils/functions/hasPermissions';
import Authorities from '@/types/Authority';
import classNames from 'classnames';
import {
  StatisticDashboardModule,
  StatisticDashboardTypeColor,
} from '@/components/_common/StatisticDashboard';
import { valueType } from 'antd/lib/statistic/utils';
interface Props {
  value?: valueType;
  module: StatisticDashboardModule;
  onClick: VoidFunction;
  tooltipTitle: string;
  statisticTitle: string;
  color: StatisticDashboardTypeColor;
}

function DashboardStatisticCard({
  value,
  module,
  onClick,
  tooltipTitle,
  statisticTitle,
  color,
}: Props) {
  const handlerPermission = () => {
    if (module === StatisticDashboardModule.workOrder) {
      return !hasPermissions([Authorities.MOVIMENTATION_WORKORDER_VIEW]);
    } else if (module === StatisticDashboardModule.accountReceivable) {
      return !hasPermissions([
        Authorities.FINANCIAL_ACCOUNT_RECEIVABLE_VIEW,
        Authorities.FINANCIAL_ACCOUNT_RECEIVABLE_LAUCH,
      ]);
    } else {
      return !hasPermissions([
        Authorities.FINANCIAL_ACCOUNT_PAYABLE_INSTALLMENTS_VIEW,
        Authorities.FINANCIAL_ACCOUNT_PAYABLE_INSTALLMENTS_LAUNCH,
      ]);
    }
  };

  return (
    <>
      <ContentWrapper
        style={{ padding: '16px' }}
        extraStyle={{ top: '10px', right: '8px' }}
        className={classNames('header-statistic-action', {
          '--disabled': handlerPermission(),
        })}
        onClick={onClick}
      >
        <Tooltip title={tooltipTitle}>
          <Statistic
            value={value}
            title={statisticTitle}
            valueStyle={{ color }}
          />
        </Tooltip>
      </ContentWrapper>
    </>
  );
}

export default DashboardStatisticCard;
